import vine from '@vinejs/vine'

// Bug vine 4.4.0 : `~standard.validate` renvoie `issue.path` en chaîne (`"identity.firstName"`) au
// lieu du tableau exigé par la spec Standard Schema → TanStack Form itère la chaîne caractère par
// caractère et ne rattache pas les erreurs aux champs. On patche une fois, globalement, la sortie
// `~standard` de tout validateur produit par `vine.create` / `vine.compile`.
/* eslint-disable @typescript-eslint/no-explicit-any */
const fixStandardPaths = (validator: any) => {
  const standard = validator?.['~standard']
  if (!standard || standard.__pathsPatched) return validator
  const original = standard.validate.bind(standard)
  standard.validate = async (value: unknown) => {
    const result = await original(value)
    if (result && Array.isArray(result.issues)) {
      return {
        issues: result.issues.map((issue: any) => ({
          ...issue,
          path: typeof issue.path === 'string' ? issue.path.split('.') : issue.path,
        })),
      }
    }
    return result
  }
  standard.__pathsPatched = true
  return validator
}

let patched = false

export const patchVineStandardSchema = () => {
  if (patched) return
  patched = true
  const anyVine = vine as any
  const originalCreate = anyVine.create.bind(vine)
  const originalCompile = anyVine.compile.bind(vine)
  anyVine.create = (...args: unknown[]) => fixStandardPaths(originalCreate(...args))
  anyVine.compile = (...args: unknown[]) => fixStandardPaths(originalCompile(...args))
}
/* eslint-enable @typescript-eslint/no-explicit-any */
